export const AdBannerFallback = (
  <div className="top-banner-fallback h-20 bg-[#0b131d] relative py-4">
    <div className="animate-pulse h-full relative rounded-full bg-slate-700/50 max-w-[1400px] mx-auto"></div>
  </div>
);
